import React from "react";
import { useFocus } from "../../common/forms/useFocus";
import { CriterionLabel } from "./components/common/CriterionLabel";
import { eventInputType } from "../../common/types/common";

interface TextInputProps {
	autoFocus?: boolean;
	error?: string;
	disabled?: boolean;
	id: string;
	label: string;
	name: string;
	onChange: (e: eventInputType) => void;
	onFocus?: React.ReactEventHandler<HTMLInputElement>;
	onKeyDown?: React.ReactEventHandler<HTMLInputElement>;
	placeholder?: string;
	prefix?: string;
	value?: string;
	onBlur?: React.ReactEventHandler<HTMLInputElement>;
}

export function TextInput({
	autoFocus,
	disabled,
	error,
	label,
	id,
	name,
	onFocus,
	onChange,
	onKeyDown,
	placeholder,
	prefix,
	value,
	onBlur,
}: TextInputProps) {
	const { ref } = useFocus(autoFocus);

	return (
		<>
			<label htmlFor={id}>
				{<CriterionLabel label={label} prefix={prefix} />}
			</label>
			{error && <span className="error-text">{error}</span>}
			<input
				type="text"
				ref={ref}
				id={id}
				name={name}
				value={value}
				placeholder={placeholder}
				autoComplete="off"
				disabled={disabled}
				onFocus={onFocus}
				onChange={onChange}
				onKeyDown={onKeyDown}
				data-criterion={true}
				onBlur={onBlur}
			/>
		</>
	);
}
